import React, { useState, useEffect, useRef } from 'react';
import { FaCircle } from 'react-icons/fa';
import image1 from '../assets/img/3.jpeg'; 
import image2 from '../assets/img/17.png';
import image3 from '../assets/img/10.jpeg';
import image4 from '../assets/img/wavecrest1.jpeg';
import image5 from '../assets/img/2.jpeg';
import image6 from '../assets/img/1o.png';
import image7 from '../assets/img/Wavecrest.2.png';

const Home = () => {
  const [contents] = useState([
    {
      backgroundImage: image1,
      text: 'African Development Foundation, where passion meets purpose',
    },
    {
      backgroundImage: image2,
      text: 'Together, we can make a difference in the lives of people.',
    },
    {
      backgroundImage: image3,
      text: 'Join us in building a brighter future through impactful programs.',
    }
  ]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % contents.length);
    }, 6000); // Change content every 6 seconds

    return () => clearInterval(timer);
  }, [contents.length]);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const deltaX = touchStartX.current - touchEndX.current;
    if (deltaX > 50) {
      // Swiped left
      setCurrentIndex((currentIndex + 1) % contents.length);
    } else if (deltaX < -50) {
      // Swiped right
      setCurrentIndex((currentIndex - 1 + contents.length) % contents.length);
    }
  };

  return (
    <div className='w-full flex' name='home'>
    <div
      
      className='lg:mt-20 lg:w-1/2 w-full lg:h-full md:h-[70vh] h-[55vh] overflow-hidden'
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className='lg:max-w-[900px] mx-auto mt-36 px-8 gap-36 flex flex-col justify-center h-full'>
        <h1 className='text-4xl lg:text-4xl font-bold text-white font-montserrat'>
          {contents[currentIndex].text}
        </h1>
        <div className='flex flex-row justify-center'>
          {/* {contents.map((_, index) => (
          <FaCircle
            key={index}
            className={`flex text-xs mx-1 cursor-pointer lg:bottom-4 md:bottom-4 bottom-4 ${
              currentIndex === index ? 'text-[#15381b]' : 'text-gray-400'
            }`}
            style={{ left: `calc(50% - ${contents.length * 10}px + ${index * 20}px)` }}
            onClick={() => setCurrentIndex(index)}
          />
        ))} */}
        </div>
      </div>
      
      {contents.map((content, index) => (
  <div
    key={index}
    className={`absolute lg:top-[15px] md:top-[10px] top-0 left-0 w-full h-[65vh] lg:h-[459px] md:h-full overflow-hidden transition-opacity duration-500 ${
      currentIndex === index ? 'opacity-100' : 'opacity-0'
    }`}
    style={{ zIndex: -1 }}
  >
    <img
      src={content.backgroundImage}
      alt={`Background ${index + 1}`}
      className={`lg:w-1/2 w-full h-[65vh] lg:h-[459px] md:h-full absolute  lg:top-[15px] md:top-[10px] top-0 left-0 opacity-0 transition-opacity duration-500 ${
        currentIndex === index ? 'opacity-100' : ''
      }`}
      style={{ zIndex: -1 }}
    />
    {/* Dark overlay */}
    <div className='absolute top-0 left-0 w-full h-full bg-black opacity-50'></div>
  </div>
))}
    </div>
    <div className='hidden lg:block xl:block lg:w-1/2 xl:w-1/2 2xl:w-1/2 xl:h-full lg:mt-[68px] xl:mt-[84px] 2xl:mt-[80px]  items-center justify-center pl-[5px]'>
      <div className='grid grid-cols-2 mt-[8px] right-0 gap-[5px]'>
        <img src={image4} alt='Image 1' className='w-full h-[187px]  ' />
        <img src={image5} alt='Image 2' className='w-full h-[187px]  ' />
        <img src={image6} alt='Image 3' className='w-full h-[187px]  ' />
        <img src={image7} alt='Image 4' className='w-full h-[187px]  ' />
      </div>
    </div>
    </div>
  );
};

export default Home;
